import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const PolicyRequest = {
  // Fetch filtered list of termsConditions
  termsConditionsFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getTermsConditionsFilterSet}`, {
      withCredentials: true,
      params: {
        isActive: values?.isActive,
      },
    }),

  // Fetch a single termsConditions by ID
  getTermsConditionsById: (termsConditionsId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getTermsConditionById}/${termsConditionsId}`, // Send id directly in the URL
      {
        withCredentials: true,
      }
    ),

  // Create a new termsCondition
  createTermsConditions: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createTermsCondition}`, values, {
      withCredentials: true,
    }),

  // Update an existing terms condition by ID
  updateTermsConditions: (termsConditionsId, values) =>
    api.put(
      `${API_URL.BASEURL}${API_URL.updateTermsCondition}/${termsConditionsId}`, // Send ID directly in the URL
      values,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json", // Ensure that the request body is being treated as JSON
        },
      }
    ),

  // Fetch filtered list of policy
  policyFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getPolicyFilterSet}`, {
      withCredentials: true,
      params: {
        isActive: values?.isActive,
      },
    }),

  // Fetch a single policy by ID
  getPolicyById: (policyId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getPolicyById}/${policyId}`, // Send id directly in the URL
      {
        withCredentials: true,
      }
    ),

  // Create a new policy
  createPolicy: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createPolicy}`, values, {
      withCredentials: true,
    }),

  // Update an existing policy by ID
  updatePolicy: (policyId, values) =>
    api.put(
      `${API_URL.BASEURL}${API_URL.updatePolicy}/${policyId}`, // Send ID directly in the URL
      values,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json", // Ensure that the request body is being treated as JSON
        },
      }
    ),

  // Fetch filtered list of panaltyStructure
  panaltyStructureFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getPanaltyStructureFilterSet}`, {
      withCredentials: true,
      params: {
        isActive: values?.isActive,
      },
    }),

  // Fetch a single panaltyStructure by ID
  getPanaltyStructureById: (panaltyStructureId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getPanaltyStructureById}/${panaltyStructureId}`, // Send id directly in the URL
      {
        withCredentials: true,
      }
    ),

  // Create a new panaltyStructure
  createPanaltyStructure: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createPanaltyStructure}`, values, {
      withCredentials: true,
    }),

  // Update an existing panaltyStructure by ID
  updatePanaltyStructure: (panaltyStructureId, values) =>
    api.put(
      `${API_URL.BASEURL}${API_URL.updatePanaltyStructure}/${panaltyStructureId}`, // Send ID directly in the URL
      values,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json", // Ensure that the request body is being treated as JSON
        },
      }
    ),
};

export default PolicyRequest;
